import axios from 'axios';
import { BASE_URL, REPORTING } from './endpoints';
const BASE_URL_HARDCODE = 'https://prod-api.vegapay.tech'
const REPORTING_URL = `${BASE_URL_HARDCODE}${REPORTING.BASE}`;

export const fetchReportData = (data: Record<string, string> | Object) => {
    return axios.post(`${REPORTING_URL}/fetchReport`, data);
  };
